module.exports = __webpack_public_path__ + "img/developer.93dc658a.png";